<template>
  <div>
    <Modal
      v-model="modalShow"
      :title="title"
      footer-hide
      width="1000"
      class-name="no-adding-modal">
      <codemirror ref="showCm" v-model="content" :options="showCmOptions"></codemirror>
    </Modal>
  </div>
</template>

<script>
import codemirror from '../ops-center/scriptUse.js'

export default {
  name: 'script-show',
  components: {
    codemirror
  },
  data () {
    return {
      modalShow: false,
      title: '配置备份内容',
      content: '',
      showCmOptions: {
        mode: {
          name: 'shell'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        theme: 'monokai',
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      }
    }
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.showCm.editor
      return editor
    }
  },
  methods: {
    openModal (data, versionView = true, onlyView = false) {
      if (!data) {
        this.$Notice.warning({ title: '无数据' })
        return false
      }
      this.content = data.content
      this.myCodeMirror.setSize('100%', 600)
      this.myCodeMirror.refresh()
      this.modalShow = true
    }
  }
}
</script>

<style lang="less">
  @import '../ops-center/base.less';
  .ivu-poptip-body {
    text-align: left !important;
  }
  .CodeMirror{
    font-size: 15px;
  }
  .CodeMirror-fullscreen {
    z-index: 999 !important;
  }
  .CodeMirror-hints {
    z-index: 1000 !important;
  }
  .no-adding-modal .ivu-modal-body {
    padding: 0;
  }
</style>
